import { validateEnv } from './validateEnv'

export const env = import.meta.env.MODE

const envVars = validateEnv(import.meta.env)

export const version = envVars.VITE_VERSION

export const apiEndpoints = envVars.VITE_KONG_LIMA_BASE_URL

export const irwin = {
  baseUrl: envVars.VITE_KONG_LIMA_BASE_URL,
  appUrl: envVars.VITE_IRWIN_APP_URL,
}

export const factset = {
  oidcAuthority: envVars.VITE_FACTSET_OIDC_AUTHORITY,
  oidcClientId: envVars.VITE_FACTSET_OIDC_CLIENT_ID,
}

// The feature-flag proxy URL falls back to the raw VITE_IRWIN_BASE_URL, never irwin.baseUrl —
// the flag client must always reach Irwin directly, never through Kong/LIMA.
export const featureFlagConfig = {
  url: `${envVars.VITE_FEATURE_FLAGS_BASE_URL || envVars.VITE_IRWIN_BASE_URL}/admin/feature/flags/proxy`,
  clientKey: envVars.VITE_FEATURE_FLAGS_KEY,
  refreshInterval: 600,
  appName: 'admin-fe',
  environment: env,
}

export const mui = { dataGridKey: envVars.VITE_MUI_DATAGRID_KEY }

export const aws = { geoplacesApiKey: envVars.VITE_GEOPLACES_API_KEY }
